const data = {
  title: "Floor 1-1",
  musicTrack: "MUSIC_WORLD1",
  story: "FLOOR ONE - BOTTOM OF THE CORPORATE LADDER",
  theme: "BLUE",
  tilesWidth: 9,
  tilesHeight: 3,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 5,
      y: 2,
    },
  ],
};

export default data;
